// Single source of truth for where the API lives.
//
// Same-origin whenever the page is served from any barriobucks.com host
// (apex, www, dev). Pointing a page on www.barriobucks.com at the API on
// barriobucks.com made every call cross-origin, and iOS in-app browsers
// (Google app, Instagram, etc.) drop the session cookie on cross-origin
// responses -- admins looked signed in but every API call was anonymous.
// Same-origin requests never hit that path and need no CORS preflight.
export const getBaseURL = () => {
  const { hostname, origin } = window.location;
  if (hostname === 'barriobucks.com' || hostname.endsWith('.barriobucks.com')) {
    return origin;
  }
  // Local dev (localhost:3000) and anything else talks to production.
  return 'https://barriobucks.com';
};

export const API_URL = `${getBaseURL()}/api`;
